import { Link } from 'react-router-dom';
import { tagColors } from '../constants';

function ProjectCard({ id, slug, title = 'Project Title', description = 'Description text', tags = [], logo, image, delay = 0 }) {
  const content = (
    <div className="aspect-[4/3] relative overflow-hidden rounded-lg group">
      {/* Background Image */}
      {image ? (
        <img 
          src={image} 
          alt={title} 
          className="absolute inset-0 w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-300"
        />
      ) : (
        <div className="absolute inset-0 bg-[#F7F7F7] flex items-center justify-center">
          <span className="text-text-muted text-xs">Project {id}</span>
        </div>
      )}
      
      {/* Tags at Top Left */}
      {tags.length > 0 && (
        <div className="absolute top-3 left-3 flex flex-wrap gap-1.5 z-10">
          {tags.map((tag, index) => {
            const colorClass = tagColors[tag.toLowerCase()] || 'bg-[#E5E5E5] text-[#666666]';
            
            return (
              <span
                key={index}
                className={`inline-block px-2 py-0.5 text-xs xl:text-sm font-normal rounded ${colorClass}`}
              >
                {tag}
              </span>
            );
          })}
        </div>
      )}

      {/* White Frame at Bottom */}
      <div className="absolute bottom-3 left-3 right-3 bg-white rounded-lg py-2 px-[0.6rem] shadow-sm">
        <div className="flex items-center gap-3">
          {/* Logo/Image */}
          {(logo || image) && (
            <div className="flex-shrink-0 w-12 h-12 md:w-14 md:h-14 bg-[#F7F7F7] rounded-md flex items-center justify-center overflow-hidden">
              <img 
                src={logo || image} 
                alt={`${title} ${logo ? 'logo' : 'image'}`} 
                className="w-full h-full object-cover" 
              />
            </div>
          )}
          
          {/* Title and Description */}
          <div className="flex-1 min-w-0">
            <div className="text-base md:text-lg font-medium text-primary">{title}</div>
            <div className="text-xs md:text-sm text-text-muted line-clamp-2">{description}</div>
          </div>

          {/* Circular Button with Arrow */}
          {slug && (
            <Link 
              to={`/${slug}`}
              className="flex-shrink-0 w-12 h-12 md:w-14 md:h-14 bg-[#E5E5E5] rounded-md flex items-center justify-center group-hover:bg-[#CBFB8F] transition-colors duration-300"
              onClick={(e) => e.stopPropagation()}
            >
              <span className="material-symbols-outlined text-[#0D0D0D] text-lg md:text-xl group-hover:rotate-45 transition-transform duration-300">
                north_east
              </span>
            </Link>
          )}
        </div>
      </div>
    </div>
  );

  if (slug) {
    return (
      <Link 
        to={`/${slug}`}
        className="block animate-fade-in-up hover:shadow-[0_2px_8px_rgba(0,0,0,0.08)] transition-all"
        style={{ animationDelay: `${delay}s` }}
      >
        {content}
      </Link>
    );
  }

  return (
    <div 
      className="animate-fade-in-up hover:shadow-[0_2px_8px_rgba(0,0,0,0.08)] transition-all"
      style={{ animationDelay: `${delay}s` }}
    >
      {content}
    </div>
  );
}

export default ProjectCard;
